/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { css, useTheme } from "@emotion/react";
import { EN_REMINDERS } from "helpers/reminders_en";
import { transformString } from "helpers/colors";
import ReactMarkdown from "react-markdown";
import { useLanguage } from "LanguageContext";
import { useAnalysis } from "../FormComponents/AnalysisResultContext";

interface RemindersProps {
  title: string;
  content: string;
}

export default function Reminders(props: RemindersProps) {
  const transformed_reminder = transformString(props.title);
  const theme = useTheme();
  const {t} = useLanguage();
  const { analysisContextResult } = useAnalysis();
  const reminder = EN_REMINDERS[
    transformed_reminder as keyof typeof EN_REMINDERS
  ] as string;

  const botContainerStyle = css`
    background: ${theme.colors.grey};
    font-size: ${theme.typography.body.fontSize};
    padding: 16px;
    li {
      padding-left: 8px;
    }
  `;

  const markdownContent =
    props.title.startsWith("frameworks_") && props.title.includes("title_principle_")
      ? t(`${props.title}_rec`, null, analysisContextResult?.locale_code)
      : props.content;

  return (
    <div css={botContainerStyle}>
      <ReactMarkdown>{markdownContent}</ReactMarkdown>
    </div>
  );
}
